import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a2d66de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "sw-calousel--container" }
const _hoisted_3 = { class: "carousel__item" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "carousel__item" }
const _hoisted_6 = {
  href: "/manga-gp2022/",
  title: "異世界WEBTOON大賞",
  target: "_blank"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "carousel__item" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "carousel__item" }
const _hoisted_11 = {
  href: "/manga-gp2022/",
  title: "異世界WEBTOON大賞",
  target: "_blank"
}
const _hoisted_12 = ["src"]

import {
  computed,
  ref,
} from 'vue';
import {
  Carousel,
  Pagination,
  Navigation,
  Slide,
} from 'vue3-carousel';
/**
 * class 属性
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'SwCalousel',
  setup(__props) {

const classes = computed(() => ({
  'sw-calousel': true,
}));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Carousel), {
          itemsToShow: 1.85,
          wrapAround: true,
          autoplay: 6000
        }, {
          addons: _withCtx(() => [
            _createVNode(_unref(Navigation)),
            _createVNode(_unref(Pagination))
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Slide), { index: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_router_link, { to: "/first" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('@/assets/img/top-calousel-01.jpg'),
                        class: "d-block w-100",
                        alt: "スポットライトとは"
                      }, null, 8, _hoisted_4)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Slide), { index: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", _hoisted_6, [
                    _createElementVNode("img", {
                      src: require('@/assets/img/top-calousel-05.jpg'),
                      class: "d-block w-100",
                      alt: "異世界WEBTOON大賞"
                    }, null, 8, _hoisted_7)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Slide), { index: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_link, { to: "/first" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('@/assets/img/top-calousel-01.jpg'),
                        class: "d-block w-100",
                        alt: "スポットライトとは"
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Slide), { index: 3 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", _hoisted_11, [
                    _createElementVNode("img", {
                      src: require('@/assets/img/top-calousel-05.jpg'),
                      class: "d-block w-100",
                      alt: "異世界WEBTOON大賞"
                    }, null, 8, _hoisted_12)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["itemsToShow"])
      ])
    ])
  ], 2))
}
}

})